import { render, staticRenderFns } from "./my-frame.vue?vue&type=template&id=3cb759e5&scoped=true&"
import script from "./my-frame.vue?vue&type=script&lang=js&"
export * from "./my-frame.vue?vue&type=script&lang=js&"
import style0 from "./my-frame.vue?vue&type=style&index=0&id=3cb759e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb759e5",
  null
  
)

export default component.exports